<template>
  <!-- 报表页统一容器（报表导航由系统左侧菜单承担，这里不再重复渲染） -->
  <div class="report-layout">
    <slot/>
  </div>
</template>

<script>
/**
 * 报表页容器
 *
 * 早期版本在页面内做过一套报表目录，和系统左侧菜单重复，已移除；
 * 保留这个容器是为了统一报表页的高度与外层间距。
 */
export default {
  name: "ReportLayout",
  props: {
    // 报表标识，保留给页面声明用
    active: {default: ""},
  },
};
</script>

<style lang="scss" scoped>
.report-layout {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
</style>
